import { render } from "./chart-of-account.svg?vue&type=template&id=3cddc075"
const script = {}
script.render = render

export default script